export default __webpack_public_path__ + "static/media/7.05f40b4a.jpg";